import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, Col, PageHeader, Row, Spin, Tag, Typography } from 'antd';
import { Header } from 'components/header';
import { GraduationCapIcon } from 'components/icons';
import { Link } from 'components/link';
import { useSkills } from './query';
import styles from './styles.less';

const { Text } = Typography;
const SHOW_TECHNOLOGY_COUNT = 5;
const GUTTER_SIZE = 7;

export const SkillsAndAchievementsBlock: FC = () => {
  const { data, loading, error } = useSkills();

  const { t } = useTranslation('translation');

  if (loading) {
    return (
      <PageHeader ghost={false}>
        <Spin />
      </PageHeader>
    );
  }

  if (error || !data) {
    return <PageHeader ghost={false}>Error</PageHeader>;
  }

  const technologiesToShow =
    data?.employee.technologies?.slice(0, SHOW_TECHNOLOGY_COUNT) || [];
  const technologiesLeft =
    (data?.employee.technologies?.length || 0) - technologiesToShow.length;

  return (
    <PageHeader
      ghost={false}
      title={<Header level={4}>{t('Skills and Achievements')}</Header>}
    >
      <Row gutter={[0, GUTTER_SIZE]}>
        {technologiesToShow.map((skill) => (
          <Col key={skill.name}>
            <Tag key={skill.name}>{skill.name}</Tag>
          </Col>
        ))}
        {technologiesLeft > 0 && (
          <Col className={styles['align-center']}>
            <Text>
              +{technologiesLeft} {t('more')}
            </Text>
          </Col>
        )}
      </Row>
      <Row align="stretch">
        <Col span={14}>
          <Link
            name="to-certificates-link"
            to=""
            className={styles['certificates-link']}
          >
            + {data?.employee.certificates?.length} {t('certificates')}
          </Link>
        </Col>
        <Col span={10} className={styles['icon-container']}>
          <Avatar
            icon={<GraduationCapIcon width={24} height={24} fill="#91C1FF" />}
            size={70}
          />
        </Col>
      </Row>
    </PageHeader>
  );
};
